document.addEventListener("DOMContentLoaded", () => {
  const miniCart = document.getElementById("mini-cart");
  if (!miniCart) return;

  const badgeEl = document.querySelector("[data-cart-count]");
  const totalEl = document.querySelector("[data-mini-cart-total]");
  let state = null;
// ===============================
// CART QUEUE
// ===============================
  const pendingUpdates = new Map();
/* ===============================================
      OPEN / CLOSE
================================================== */
  const miniCartPanel = miniCart.querySelector(".mini-cart-panel");
  const miniCartBackdrop = miniCart.querySelector(".mini-cart-overlay");
  const miniCartCloseBtn = miniCart.querySelector(".mini-cart-close, [data-mini-cart-close]");

  const miniCartController = window.AllierUI?.OverlayController({
    root: miniCart,
    panel: miniCartPanel || miniCart,
    backdrop: miniCartBackdrop || null,
    openClass: "is-open",
    lockScroll: false,
    closeOnEscape: true,
    closeOnBackdrop: true,
    trapFocus: true,
    initialFocus: () =>
      miniCartCloseBtn ||
      miniCart.querySelector("a, button, input, textarea, select, [tabindex]:not([tabindex='-1'])")
  });

    function openMiniCart(triggerEl = null) {
      if (miniCartController) {
        miniCartController.open(triggerEl);
        return;
      }
      miniCart.classList.add("is-open");
      miniCart.setAttribute("aria-hidden", "false");
    }

    function closeMiniCart() {
        if (miniCartController) {
          miniCartController.close();
          return;
        }
        miniCart.classList.remove("is-open");
        miniCart.setAttribute("aria-hidden", "true");
      }
      window.closeMiniCart = closeMiniCart;

  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("[data-mini-cart-open]");
    const closeBtn = e.target.closest("[data-mini-cart-close]");

    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      openMiniCart(openBtn);
      return;
    }
    if (closeBtn) {
      e.preventDefault();
      closeMiniCart();
    }
});

/* ==================================================
    INIT STATE
================================================== */
  async function initState() {
    const res = await fetch("/cart.js");
    state = await res.json();
    syncUI(state);
  }

/* ==================================================
    SYNC
================================================== */
  function syncUI(cart) {
    syncBadge(cart);
    syncMiniCartTotal(cart);
    syncMiniCartFooter(cart);
    syncCartPageMobilePrices(cart);
  }

  function syncBadge(cart) {
    if (!badgeEl) return;

    const prev = Number(badgeEl.textContent) || 0;
    const next = cart.item_count;

    badgeEl.textContent = next;
    badgeEl.classList.toggle("hidden", next === 0);

    if (prev !== next) {
      badgeEl.classList.remove("cart-badge-animate");
      badgeEl.offsetHeight;
      badgeEl.classList.add("cart-badge-animate");
    }
  }

  function syncMiniCartTotal(cart) {
    if (!totalEl) return;
    totalEl.innerHTML = window.theme.formatMoney(cart.total_price);
  }

  function syncMiniCartFooter(cart) {
    const footer = document.querySelector("[data-mini-cart-footer]");
    if (!footer) return;
    footer.classList.toggle("is-visible", cart.item_count > 0);
  }

  function syncCartPageMobilePrices(cart) {
    cart.items.forEach(item => {
      const row = document.querySelector(
        `.cart-item[data-key="${CSS.escape(item.key)}"]`
      );
      if (!row) return;

      const priceEl = row.querySelector("[data-cart-mobile-line-price]");
      if (!priceEl) return;

      priceEl.innerHTML = window.theme.formatMoney(item.final_line_price);
    });
  }

/*==================================================
      REFRESH 
================================================== */
async function refreshMiniCartSection() {
  try {
    const miniCart = document.getElementById("mini-cart");
    if (!miniCart) return;

    const current = miniCart.querySelector("[data-mini-cart-section]");
    if (!current) return;

    const res = await fetch("/?sections=mini-cart-ajax", {
      headers: { Accept: "application/json" }
    });

    if (!res.ok) throw new Error("Failed to reload mini cart");

    const sections = await res.json();
    const html = sections["mini-cart-ajax"];
    if (!html) return;

    const temp = document.createElement("div");
    temp.innerHTML = html;

    const incoming = temp.querySelector("#shopify-section-mini-cart-ajax");
    if (!incoming) return;

    current.innerHTML = incoming.innerHTML;

  } catch (err) {
    console.error("[MiniCart refresh]", err);
  }
}
async function refreshCartPageSection() {
  const cartContent = document.querySelector(".cart-content");
    if (!cartContent) return;

    const res = await fetch("/cart?section_id=main-cart");
    const html = await res.text();

    const temp = document.createElement("div");
    temp.innerHTML = html;

    const newContent = temp.querySelector(".cart-content");
    if (newContent) cartContent.innerHTML = newContent.innerHTML;
}

/* ==================================================
    UPDATE ITEM
================================================== */
  window.updateItem = function (key, qty) {
    const entry = pendingUpdates.get(key) || { inFlight: false, qty };
    entry.qty = qty;
    pendingUpdates.set(key, entry);

    if (!entry.inFlight) processCartQueue(key);
  };

  async function processCartQueue(key) {
    const entry = pendingUpdates.get(key);
    if (!entry) return;

    entry.inFlight = true;

    try {
      while (true) {
        const qtyToSend = entry.qty;

        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ id: key, quantity: qtyToSend })
        });

        if (!res.ok) throw new Error("Cart update failed");

        state = await res.json();

        if (entry.qty !== qtyToSend) continue;

        await refreshMiniCartSection();
        await refreshCartPageSection();

        syncBadge(state);
        syncMiniCartTotal(state);
        syncMiniCartFooter(state);
        syncGiftWrapToggle(state);

        break;
      }
    } catch (err) {
      console.error(err);
      await initState();
    } finally {
      entry.inFlight = false;
      pendingUpdates.delete(key);
    }
  }

/* ==================================================
    ADD TO CART
================================================== */
document.addEventListener("submit", async (e) => {
  const form = e.target.closest('form[action="/cart/add"]');
  if (!form || form.dataset.loading === "true") return;

  e.preventDefault();
  form.dataset.loading = "true";
  const submitButton = form.querySelector('[type="submit"]');

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.setAttribute("aria-disabled", "true");
    if (submitButton.classList.contains("quick-add-bar__button")) {
      submitButton.classList.add("is-loading");
    }
  }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" }
    });
    const data = await response.json();

    if (!response.ok) {
      console.error("Add to cart error:", data);
      return;
    }
    if (submitButton?.classList.contains("quick-add-bar__button")) {
      submitButton.classList.remove("is-loading");
      submitButton.classList.add("is-success");

      setTimeout(() => {
        submitButton.classList.remove("is-success");
      }, 1200);
    }
    await initState();
    await refreshMiniCartSection();
    syncGiftWrapToggle(state);
    openMiniCart();

  } catch (error) {
    console.error("Add to cart network error:", error);

  } finally {
    form.dataset.loading = "false";
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.setAttribute("aria-disabled", "false");
      submitButton.classList.remove("is-loading");
    }
  }
});

/* ==================================================
    QTY
================================================== */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-action]");
    if (!btn) return;

    const wrap = btn.closest("[data-quantity]");
    if (!wrap) return;

    const valueEl = wrap.querySelector("[data-qty-value]");
    const inputEl = wrap.querySelector("[data-qty-input]");
    if (!valueEl) return;

    const current = Number(inputEl?.value ?? valueEl.textContent);
    const next = btn.dataset.action === "plus"
      ? current + 1
      : Math.max(1, current - 1);

    if (inputEl) inputEl.value = next;
    valueEl.textContent = next;

    const key = wrap.dataset.key;
    if (key) updateItem(key, next);
  });

/* ===============================================
    REMOVE
================================================== */
document.addEventListener("click", async (e) => {
  const btn = e.target.closest("[data-remove]");
  if (!btn) return;

  e.preventDefault();

  const key = btn.dataset.key;
  if (!state) await initState();

  const removingItem = state?.items?.find(i => i.key === key);
  const giftWrapVariantId = getAnyGiftWrapVariantId();
  const isRemovingGiftWrap = giftWrapVariantId && (removingItem?.variant_id === giftWrapVariantId);

  if (isRemovingGiftWrap) {
    const toggles = document.querySelectorAll('.js-gift-wrap-toggle');
    toggles.forEach(t => (t.checked = false));
  }
  // Animation
  const row = miniCart.querySelector(`[data-key="${CSS.escape(key)}"]`);
  if (!row) {
    updateItem(key, 0);
    return;
  }

  const items = [...miniCart.querySelectorAll(".mini-cart-item")];
  const firstRects = items.map(el => ({
    el,
    top: el.getBoundingClientRect().top
  }));

  row.classList.add("is-removing");
  setTimeout(() => { row.remove(); }, 220);
  updateItem(key, 0);

  requestAnimationFrame(() => {
    const remaining = [...miniCart.querySelectorAll(".mini-cart-item")];

    remaining.forEach(el => {
      const first = firstRects.find(r => r.el === el);
      if (!first) return;

      const lastTop = el.getBoundingClientRect().top;
      const deltaY = first.top - lastTop;
      if (!deltaY) return;

      el.style.transform = `translateY(${deltaY}px)`;
      el.style.transition = "none";

      requestAnimationFrame(() => {
        el.style.transform = "";
        el.style.transition = "";
      });
    });
  });
});

// ===============================
// PRODUCT CARD – ADD TO CART
// ===============================
document.addEventListener("click", async (e) => {
  const cta = e.target.closest("[data-add-to-cart]");
  if (!cta || cta.dataset.loading === "true") return;

  e.preventDefault();

  const productId = cta.dataset.productId;
  const variantId = cta.dataset.variantId;
  const productTitle = cta.dataset.productTitle;

  if (!variantId) {
    console.error("Product card add to cart error: missing variantId", {
      productId,
      productTitle
    });
    return;
  }
  cta.dataset.loading = "true";
  cta.classList.add("is-loading");

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Product card add to cart error:", data);
      return;
    }

    cta.classList.remove("is-loading");
    cta.classList.add("is-success");

    setTimeout(() => {
      cta.classList.remove("is-success");
    }, 1200);

    // ANALYTICS
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: cta.dataset.currency,
          items: [{
            item_id: cta.dataset.productId,
            item_name: cta.dataset.productTitle,
            item_variant: variantId,
            price: Number(cta.dataset.productPriceCents) / 100,
            quantity: 1,
            item_list_name: "product_card"
          }]
        }
      });
    }
    await initState();
    await refreshMiniCartSection();
    syncGiftWrapToggle(state);
    openMiniCart();
  } catch (error) {
    console.error("Product card add to cart network error:", error);
  } finally {
    cta.dataset.loading = "false";
    cta.classList.remove("is-loading");
  }
});

/* ===============================================
    CART NOTE
================================================== */
(function initCartNote() {
  let timer = null;

  function saveNote(noteField) {
    clearTimeout(timer);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: noteField.value.trim() })
    }).catch((err) => console.warn('[Cart note] update failed:', err));
  }

  document.addEventListener('input', (event) => {
    const noteField = event.target.closest('[data-cart-note]');
    if (!noteField) return;

    clearTimeout(timer);
    timer = setTimeout(() => saveNote(noteField), 400);
  });

  document.addEventListener('blur', (event) => {
    const noteField = event.target.closest('[data-cart-note]');
    if (!noteField) return;

    saveNote(noteField);
  }, true);
})();

/* ==================================================
   GIFT WRAP
================================================== */
function getGiftWrapVariantIdFromToggle(toggle) {
  const v = Number(toggle?.dataset?.giftWrapVariantId);
  return Number.isFinite(v) ? v : 0;
}

function getAnyGiftWrapVariantId() {
  const anyToggle = document.querySelector('.js-gift-wrap-toggle[data-gift-wrap-variant-id]');
  return getGiftWrapVariantIdFromToggle(anyToggle);
}

/* API */
async function addGiftWrap(variantId, quantity) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{ id: variantId, quantity }]
    })
  });

  if (!res.ok) {
    const t = await res.text();
    throw new Error(`addGiftWrap failed (${res.status}): ${t}`);
  }

  return res.json();
}

async function changeGiftWrapByKey(key, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: key, quantity })
  });

  if (!res.ok) {
    const t = await res.text();
    throw new Error(`changeGiftWrapByKey failed (${res.status}): ${t}`);
  }

  return res.json();
}

function syncGiftWrapToggle(cartState) {
  const toggles = document.querySelectorAll('.js-gift-wrap-toggle[data-gift-wrap-variant-id]');
  if (!toggles.length || !cartState) return;

  toggles.forEach(toggle => {
    const variantId = getGiftWrapVariantIdFromToggle(toggle);
    if (!variantId) return;

    const realProductsQty = cartState.items.reduce((sum, item) => {
      return item.variant_id === variantId ? sum : sum + item.quantity;
    }, 0);

    const hasGiftWrap = cartState.items.some(item => item.variant_id === variantId);

    toggle.checked = hasGiftWrap;
    toggle.disabled = realProductsQty === 0;
  });
}

/* Toggle */
document.addEventListener('change', async (e) => {
  const toggle = e.target.closest('.js-gift-wrap-toggle[data-gift-wrap-variant-id]');
  if (!toggle) return;

  const variantId = getGiftWrapVariantIdFromToggle(toggle);
  if (!variantId) return;
  toggle.disabled = true;

  try {
    if (!state) await initState();

    const realProductsQty = state.items.reduce((sum, item) => {
      return item.variant_id === variantId ? sum : sum + item.quantity;
    }, 0);

    const giftItem = state.items.find(item => item.variant_id === variantId);

    if (!toggle.checked || realProductsQty === 0) {
      if (giftItem) {
        await changeGiftWrapByKey(giftItem.key, 0);
      }
    } else {
      if (!giftItem) {
        await addGiftWrap(variantId, realProductsQty);
      } else {
        await changeGiftWrapByKey(giftItem.key, realProductsQty);
      }
    }

    // update
    await initState();
    await refreshMiniCartSection();
    syncGiftWrapToggle(state);

    if (typeof refreshCartPageSection === 'function') {
      await refreshCartPageSection();
    }

  } catch (err) {
    console.error('[GiftWrap]', err);
    toggle.checked = !toggle.checked;
    if (state) syncGiftWrapToggle(state);
  } finally {
    toggle.disabled = false;
  }
});

  initState();
});